import { render, staticRenderFns } from "./TasksSidebar.vue?vue&type=template&id=10f6c286&scoped=true&"
import script from "./TasksSidebar.vue?vue&type=script&lang=js&"
export * from "./TasksSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TasksSidebar.vue?vue&type=style&index=0&id=10f6c286&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f6c286",
  null
  
)

export default component.exports